import { Route } from '@angular/router';

export const betaRoutes: Route[] = [];
